import {
  pinPickupIcon,
  pinDropIcon,
} from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import Image from 'next/image';
import React from 'react';

export const MapPinCmp: React.FC = () => {
  const { state } = useLocation();
  const mapPinIcon = state.waypoint === 'Pickup' ? pinPickupIcon : pinDropIcon;

  return (
    <div
      data-testid="map-pin"
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-full pointer-events-none"
    >
      <Image src={mapPinIcon} height={50.0} width={50.0} alt={'Map Pin Icon'} />
    </div>
  );
};
